import { createSolanaAddressId } from '@pkg/solana'
import type { TokenTransfer } from '@pkg/solana'

export function isRelatedTransfer(
  tokenTransfer: TokenTransfer,
  relatedAddresses: Set<string>,
): boolean {
  if (tokenTransfer.from) {
    const fromId = createSolanaAddressId({ address: tokenTransfer.from })
    if (relatedAddresses.has(fromId)) return true
  }

  if (tokenTransfer.to) {
    const toId = createSolanaAddressId({ address: tokenTransfer.to })
    if (relatedAddresses.has(toId)) return true
  }

  return false
}
